import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as yup from "yup";
import Input from "../../components/formControls/form";
import Button from "../../components/formControls/buttons";
import ButtonLoader from "../../components/loader/buttonLoaders";
import LoginImg from "../../assets/images/loginImage.svg";
import logo from "../../assets/images/image/QbaceLogo.svg";
import passwordImg from "../../assets/images/eye.svg";
import passwordShow from "../../assets/images/eye-off.svg";
import lungs from "../../assets/images/Lungs.svg";
import copyright from "../../assets/images/copyright.svg";
import { loginUser } from "../../redux/actions/login.action";
import { EyeStyled, SiginWrapper } from "./style";

const SignIn = () => {
  const [passwordShown, setPasswordShown] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.login.loading);

  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema: yup.object({
      email: yup.string().required("Email is required").strict().email("Enter valid email"),
      password: yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      const userInputDate = {
        email: values.email.trim(),
        password: values.password.trim(),
      };
      return dispatch(loginUser(userInputDate));
    },
  });

  const isSubmitting = loading || formik.isSubmitting;

  return (
    <SiginWrapper>
      <div className="login-layout">
        {/* ── Left illustration panel ── */}
        <div className="login-left">
          <img src={LoginImg} alt="background" className="loginImg" />
          <div className="Login-description">
            <img src={lungs} className="lungsImg" alt="lungs" />
            <h1 className="login-heading">
              Hello <br />Qbace Admin 👋🏻
            </h1>
            <p className="login-desc">
              Your central hub for crafting, managing, and optimizing
              assessments. Seamlessly navigate through features, customize
              settings, and empower educators.
            </p>
            <div className="copyRightDiv">
              <img src={copyright} alt="copyright" className="copyrightImg" />
              <p className="copyright">2024 Qbace All rights reserved</p>
            </div>
          </div>
        </div>

        {/* ── Right form panel ── */}
        <div className="login-right">
          <div className="login-form-box">
            <img src={logo} alt="Qbace logo" className="qbaceLogo" />

            <div className="login-form-header">
              <h2 className="loginHeading">Login to your account</h2>
              <p className="loginSubtitle">Enter your credentials to continue</p>
            </div>

            <form onSubmit={formik.handleSubmit} noValidate>
              {/* Email */}
              <div className="field-group">
                <label className="label-text">
                  Email address <span className="mandatory">*</span>
                </label>
                <Input
                  width="100%"
                  height="44px"
                  border-radius="8px"
                  border="1px solid #E2E5E9"
                  id="login-email"
                  backgroundColor="#FFFFFF"
                  placeholder="Enter your email"
                  type="text"
                  name="email"
                  onChange={(e) => formik.setFieldValue("email", e.target.value.trim().toLowerCase())}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                <p className={`field-error ${formik.errors.email && formik.touched.email ? "visible" : ""}`}>
                  {formik.errors.email || " "}
                </p>
              </div>

              {/* Password */}
              <div className="field-group position-relative">
                <label className="label-text">
                  Password <span className="mandatory">*</span>
                </label>
                <Input
                  width="100%"
                  height="44px"
                  border-radius="8px"
                  border="1px solid #E2E5E9"
                  backgroundColor="#FFFFFF"
                  id="login-password"
                  placeholder="Enter your password"
                  type={passwordShown ? "text" : "password"}
                  name="password"
                  onChange={(e) => formik.setFieldValue("password", e.target.value.trim())}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  style={{ paddingRight: "48px" }}
                />
                <EyeStyled>
                  <img
                    src={passwordShown ? passwordImg : passwordShow}
                    alt="toggle password"
                    className="passwordIcon"
                    onClick={() => setPasswordShown((v) => !v)}
                  />
                </EyeStyled>
                <p className={`field-error ${formik.errors.password && formik.touched.password ? "visible" : ""}`}>
                  {formik.errors.password || " "}
                </p>
              </div>

              {/* Submit */}
              <div className="login-btn-wrap">
                <Button
                  text={isSubmitting ? <ButtonLoader /> : "Login"}
                  color="white"
                  width="100%"
                  height="44px"
                  id="login-button"
                  border="none"
                  background="#006AFF"
                  borderRadius="8px"
                  type="submit"
                  disabled={isSubmitting}
                  fontWeight="600"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </SiginWrapper>
  );
};

export default SignIn;
